/* eslint-disable */
import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import ReactStars from "react-rating-stars-component";
const ViewReview = ({ isOpen2, selectedId, handleSubmit = () => { }, handleSubmitReply = () => { }, setSendReply }) => {
    const [reply, setReply] = useState(false);
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            overflow: "hidden",
            top: "-40px"
        }}
        >
            <Modal
                show={isOpen2}
                onHide={handleSubmit}
                // backdrop="static"
                style={{ height: "600px", overflowY: "hidden", top: "-20px" }}
                keyboard={false}

            >
                <Modal.Header >
                    <Modal.Title>View Review</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: "400px", overflowY: "scroll" }}>
                    <div className="row">
                        <div style={{ width: "25%" }} className="listsearch-input-item col-md-4">
                            <label>Overall Satisfaction</label>
                            <ReactStars
                                count={5}
                                value={selectedId?.original?.overall_satisfaction || 0}
                                size={30}
                                activeColor="#ffd700"
                                edit={false}
                            />
                        </div>
                        <div style={{ width: "25%" }} className="listsearch-input-item col-md-4">
                            <label>Cleanliness</label>
                            <ReactStars
                                count={5}
                                value={selectedId?.original?.cleanliness || 0}
                                size={30}
                                activeColor="#ffd700"
                                edit={false}
                            />
                        </div>
                        <div style={{ width: "25%" }} className="listsearch-input-item col-md-4">
                            <label>Accuracy</label>
                            <ReactStars
                                count={5}
                                value={selectedId?.original?.accuracy || 0}
                                size={30}
                                activeColor="#ffd700"
                                edit={false}
                            />
                        </div>
                        <div style={{ width: "25%" }} className="listsearch-input-item col-md-4">
                            <label>Communication</label>
                            <ReactStars
                                count={5}
                                value={selectedId?.original?.communication || 0}
                                size={30}
                                activeColor="#ffd700"
                                edit={false}
                            />
                        </div>
                        <div style={{ width: "25%" }} className="listsearch-input-item col-md-4">
                            <label>Location</label>
                            <ReactStars
                                count={5}
                                value={selectedId?.original?.location || 0}
                                size={30}
                                activeColor="#ffd700"
                                edit={false}
                            />
                        </div>
                        <div style={{ width: "25%" }} className="listsearch-input-item col-md-4">
                            <label>Check-in</label>
                            <ReactStars
                                count={5}
                                value={selectedId?.original?.checkin || 0}
                                size={30}
                                activeColor="#ffd700"
                                edit={false}
                            />
                        </div>
                        <div style={{ width: "25%" }} className="listsearch-input-item col-md-4">
                            <label>Value</label>
                            <ReactStars
                                count={5}
                                value={selectedId?.original?.value || 0}
                                size={30}
                                activeColor="#ffd700"
                                edit={false}
                            />
                        </div>
                    </div>
                    <form id="add-comment" className="add-comment  custom-form" name="rangeCalc">
                        <fieldset>

                            <div style={{ padding: "10px 30px 0px" }} className="list-single-main-item_content fl-wrap">

                                <textarea
                                    cols={40}
                                    rows={3}
                                    value={selectedId?.original?.comment || ""}
                                    placeholder="Write Your Reason:"
                                    defaultValue={""}
                                />

                            </div>
                        </fieldset>
                        <p style={{fontSize:"11px",fontStyle:"italic"}}>Caution: Clicking No Reply is a final action; you will not be able to leave a review once it has been clicked.</p>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>

                            <Button variant="primary" onClick={() => setReply(!reply)}>Reply</Button>
                            <Button variant="primary" onClick={handleSubmit}>No Reply</Button>

                        </div>
                    </form>
                    {reply &&

                        <form id="add-comment" className="add-comment  custom-form" name="rangeCalc">
                            <fieldset>

                                <div style={{ padding: "10px 30px 0px" }} className="list-single-main-item_content fl-wrap">

                                    <textarea
                                        cols={40}
                                        rows={3}
                                        onChange={(e) => setSendReply(e.target.value)}
                                        placeholder="Write Your Reply:"
                                        defaultValue={""}
                                    />

                                </div>
                            </fieldset>
                            <p style={{fontSize:"11px",fontStyle:"italic"}}>You can only respond to a review one time. Once you click Submit, your review cannot be retracted. You have a limit of 500 characters for your reply.</p>

                            <div style={{ display: "flex", justifyContent: "flex-end" }}>

                                <Button variant="primary" onClick={handleSubmitReply}>Submit</Button>
                            </div>
                        </form>

                    }
                </Modal.Body>

            </Modal>
        </div>
    )
}

export default ViewReview